import React from 'react'
import { useTranslation } from 'react-i18next'
import CurrencyComponent from '../../../Elements/currency'
import {
	ModalHeaderBackButton, ModalHeaderBackIcon, ModalHeaderBedIcon, ModalHeaderContextIcon, ModalHeaderSubtitle, ModalHeaderTitle, ModalHeaderTitles, ModalHeaderWrap,
} from './index.styled'

const Currency = CurrencyComponent as unknown as React.ComponentType<{ children: number }>

type Props = {
	showBack: boolean
	onBack: () => void
	tableLabel?: string
	total: number
}

const RoomChargeModalHeader = React.memo(({ showBack, onBack, tableLabel, total }: Props) => {
	const { t } = useTranslation()

	return (
		<ModalHeaderWrap>
			{showBack &&
				<ModalHeaderBackButton type="button" onClick={onBack} aria-label={t('buttons.controls.back')}>
					<ModalHeaderBackIcon icon="arrow-left" />
				</ModalHeaderBackButton>}
			<ModalHeaderContextIcon>
				<ModalHeaderBedIcon icon="bed" />
			</ModalHeaderContextIcon>
			<ModalHeaderTitles>
				<ModalHeaderTitle>{t('Payments.payments.ROOM_CHARGE')}</ModalHeaderTitle>
				<ModalHeaderSubtitle>
					{tableLabel && `${t('RoomCharge.subtitle', { table: tableLabel })} · `}
					<Currency>{total}</Currency>
				</ModalHeaderSubtitle>
			</ModalHeaderTitles>
		</ModalHeaderWrap>
	)
})

RoomChargeModalHeader.displayName = 'RoomChargeModalHeader'
export default RoomChargeModalHeader
